import { createSlice } from '@reduxjs/toolkit';

export interface AuthState {
    tokenRejected: boolean;
}

const initialState: AuthState = { tokenRejected: false };

export const auth = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        tokenRejected: (state) => {
            state.tokenRejected = true;
        },
        tokenAccepted: (state) => {
            state.tokenRejected = false;
        },
    },
});

export const { tokenRejected, tokenAccepted } = auth.actions;

export const selectTokenRejected = (state: { auth: AuthState }) => state.auth.tokenRejected;
